module.exports = __webpack_public_path__ + "media/images/circle-d6db06e21d17b34e7118a1d7a4025845.svg";